module.exports = __webpack_public_path__ + "img/greenwood_property_square.55d619c0.png";